import { useQuery } from 'react-query';

import api from '../../utils/api';
import { FETCH_CAMPAIGNS } from '../../constants/endpoints';

const fetchCampaigns = () => api.get(FETCH_CAMPAIGNS);

export const useFetchCampaigns = () =>
  useQuery([FETCH_CAMPAIGNS], fetchCampaigns, {
    select: (data) =>
      data?.map((d) => ({
        value: `${d?.id}`,
        label: d?.name
      }))
  });



// WEBPACK FOOTER //
// ./src/hooks/react-query/useCampaignData.js